/**
 * Вспомогательные функции
 * @module Utils/functions
 * */

import ExportJsonExcel from 'js-export-excel'

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * Функция для склонения числительных (1 екунда, 2 секунды, 15 секунд)
 * @param {Number} number - число
 * @param {Array} titles - массив из трех строк ['секунда', 'секунды', 'секунд']
 * @returns {String} - возвращает подходящую строку
 * */
export function getDecl(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2]
  return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[Math.min(number % 10, 5)]]
}

/**
 * Возвращает имя файла из ссылки для скачивания
 * @param {String} url - url файла
 * @returns {String} - имя файла
 */
export function getFileNameFromUrl(url) {
  const arr = url.split('/')
  return arr[arr.length - 1]
}

/**
 * Экспортирует из хранилища данные в xlsx файл
 * @param {Array.<Object>} columnsSettings
 * @param {String} title
 * @param {Array.<Object>} data
 * @return {void}
 * */
export function exportDataToExcel(columnsSettings, title, data) {
  const totalWidth = columnsSettings.reduce((prev, curr) => (
    prev + parseInt(curr.headerStyle.match(/\d+/)[0], 10)
  ), 0)
  const options = {
    fileName: title,
    datas: [
      {
        sheetData: data.map(iEl => (
          Object.entries(iEl).reduce((prev, [key, val]) => {
            const settingObj = columnsSettings.find(cSEl => cSEl.field === key)
            prev[key] = settingObj?.format?.(val) ?? val
            return prev
          }, {})
        )),
        sheetFilter: columnsSettings.map(item => item.field),
        sheetName: title,
        columnWidths: columnsSettings.map((item) => (
          // Процент от общего размера
          parseInt(item.headerStyle.match(/\d+/)[0], 10) / (totalWidth / 100)
        )),
        sheetHeader: columnsSettings.map(item => item.label)
      }
    ]
  }
  const toExcel = new ExportJsonExcel(options)
  toExcel.saveExcel()
}
